import LeaveCalendar from "./LeaveCalendar";
import LeaveleaveManagement from "./LeaveManagement";
import LeaveManagementForm from "./LeaveManagementForm";


const LeaveManagementConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/leaveManagement',
            element: <LeaveleaveManagement />,
        },
        {
            path: '/LeaveManagementForm',
            element: <LeaveManagementForm />,
        },
        {
            path: '/LeaveManagementForm/:id',
            element: <LeaveManagementForm />,
        },
        {
            path: '/LeaveCalendar',
            element: <LeaveCalendar/>,
        },
    ]
}

export default LeaveManagementConfig;